// extracted by mini-css-extract-plugin
module.exports = {"orderSummary":"OrderSummary_orderSummary__3OTyJ","card":"OrderSummary_card__3ybNE","value":"OrderSummary_value__3pyPC","active":"OrderSummary_active__xyMOB"};